
export default {
    pretensaoSalarial: {},
    pretensoesSalariais: []
}